<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem cấu hình menu: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="left" :model="modelData" ref="createModel" label-width="180px" @submit.native.prevent>
            <el-form-item label="Vị trí:" class="form-item">
              <span>{{ modelData.position_txt }}</span>
            </el-form-item>
            <el-form-item label="Tên:" class="form-item">
              <span>{{ modelData.name }}</span>
            </el-form-item>
            <el-form-item label="Link:" class="form-item">
              <span>{{ modelData.link }} %</span>
            </el-form-item>
            <el-form-item label="Kích hoạt:">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                disabled
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
export default {
  name: 'PromotionShow',
  metaInfo () {
    return {
      title: 'Cấu hình menu | Xem chi tiết'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        code: '',
        discount: '',
        date_start: '',
        date_end: '',
        title: '',
        description: '',
        status: true
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configmenus-index', text: 'Cấu hình menu' },
        { name: 'configmenus-update', text: 'Xem chi tiết' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'configmenus-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('configmenus/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/configmenus/Show.vue